// 로그인 후 공통 레이아웃 — 헤더 + 내비게이션
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@taplink/web-shared";
import { TenantSwitcher } from "./TenantSwitcher.tsx";

export function AppLayout() {
  const { me, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="app-shell">
      <header className="app-header">
        <div className="app-header__inner">
          {/* 운영자 콘솔의 'tapLink 운영' 과 짝을 맞춘다 — 두 콘솔을 나란히 열어 두는
              일이 많고, 브랜드만 있으면 어느 쪽 창인지 헤더로 구별되지 않는다. */}
          <strong className="brand">tapLink 콘솔</strong>

          {/* 운영자 메뉴는 **아래 줄로 분리**한다. 한 줄에 몰아넣으면 항목이 늘어날 때마다
              flex 가 링크를 눌러 글자가 중간에서 잘린다("악용 신 고" — 실측).
              사용자 메뉴 4개는 항상 같은 자리에 있어야 하므로 그쪽을 지킨다. */}
          <nav aria-label="주요 메뉴" className="app-nav">
            <NavLink to="/" end>링크</NavLink>
            <NavLink to="/stats">통계</NavLink>
            <NavLink to="/team">팀</NavLink>
            <NavLink to="/activity">활동 기록</NavLink>
            <NavLink to="/account">내 계정</NavLink>
          </nav>

          <div className="app-header__right">
            {/* 작업 공간이 하나면 아무것도 렌더하지 않는다 — 개인 사용자에게 조직 개념이 새면 안 된다 */}
            <TenantSwitcher />
            <span className="badge">{me?.planType}</span>
            <button
              type="button"
              className="btn-link"
              onClick={() => {
                void logout().then(() => navigate("/login"));
              }}
            >
              로그아웃
            </button>
          </div>
        </div>

      </header>

      <main className="app-main">
        <Outlet />
      </main>
    </div>
  );
}
